import React from 'react';
import { formatDateTime } from './formatting';

import styles from './conversation.module.css';

// Reads the English copy when one exists and the reader has asked for it, and falls back to the
// original for any turn the provider could not translate, so a gap in the translation never leaves
// a turn of the conversation blank.
const bodyFor = (message, showEnglish) => {
  if (showEnglish && message.body_english) {
    return message.body_english;
  }

  return message.body;
};

export default function Conversation({ messages, showEnglish }) {
  if (messages.length === 0) {
    return <p className={styles.unavailable}>The conversation behind this event is no longer available.</p>;
  }

  return (
    <blockquote className={styles.conversation}>
      {messages.map((message, index) => (
        <div
          className={message.flagged ? `${styles.turn} ${styles.flagged}` : styles.turn}
          key={`${index}:${message.sent_at}`}
        >
          <p className={styles.attribution}>
            <span className={styles.role}>{message.sender_role}</span>
            <span className={styles.sent_at}>{formatDateTime(message.sent_at)}</span>
            {message.flagged && <span className={styles.flag}>Flagged</span>}
          </p>
          <p className={styles.body}>{bodyFor(message, showEnglish)}</p>
        </div>
      ))}
    </blockquote>
  );
}
